export default __webpack_public_path__ + "static/media/slide_2.34fbdb06.png";